define('views/pages/trade/request/processed/index',[
    'jquery',
    'underscore',
    'mediator',
    'models/base/modal',
    'views/base/view',
    'views/base/modal',
    'lib/utils',

    'views/pages/trade/request/processed/table',

], function($, _, mediator, ModalModel, View, ModalView, utils, ProcessedTableView) {
    'use strict';

    var ProcessedModalView = ModalView.extend({

        modalClass: 'modal-big',

        render: function() {
            ModalView.prototype.render.apply(this, arguments);

            this.$('.modal').addClass('modal-big');

            this.subview('content', new ProcessedTableView({ collection: this.model.items }));
        }
    });

    return ProcessedModalView;
});

